// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2ac8f34c","703":"2474ec3e","787":"c74ebbaa"}[chunkId] + ".chunk.js";
};